export default "__VITE_ASSET__DXXgoGSJ__"